import socialMediaColumns from './socialMediaColumns';
import gameStoreColumns from './gameStoreColumns';
import newsMediaColumns from './newsMediaColumns';
import heroColumns from './heroColumns';
import streamerColumns from './streamerColumns';
import influencerColumns from './influencerColumns';
import privateDiscordColumns from './privateDiscordColumns';
import hashtagColumns from './hashtagColumns';
import videoColumns from './videoColumns';
import accountsChartColumns from './accountsChartColumns';
import accountMetricsTableColumnsColumns from './accountMetricsTableColumns';
import summaryTopicTrendsColumns from './summaryTopicTrendsColumns';
import keyMetricsColumns from './keyMetricsColumns';
import {
  anchorWordsColumns,
  firstCorrelationWordsColumns,
  secondCorrelationWordsColumns,
} from './keywordCorrelationColumns';
import videoChartColumns from './videoChartColumns';
import steamMetricsColumns from './steamMetricsColumns';
import influencerChannel from './influencerChannel';
import influencerCounts from './influencerCounts';
import influencerPublicationAnalysisCounts from './influencerPublicationAnalysisCounts';
import steamRatingsColumns from './steamRatingsColumns';
import steamRatingsFilterSelectedColumns from './steamRatingsFilterSelectedColumns';
import steamReviewsDetailedLanguageColumns from './steamReviewsDetailedLanguageColumns';
import feedsKeywordTableColumns from './feedsKeywordTableColumns';
import overviewKeywordTableColumns from './overviewKeywordTableColumns';
import steamRealtimeColumns from './steamRealtimeColumns';
import steamRealtimeFilteredReviewsColumns from './steamRealtimeFilteredReviewsColumns';
import steamRealtimeNewlyAddedColumns from './steamRealtimeNewlyAddedColumns';
import compareByInfluencerColumns from './compareByInfluencerColumns';
import genreLanguageListColumns from './genreLanguageListColumns';
import genreCreatorListColumns from './genreCreatorListColumns';
import trendingVideoColumns from './trendingVideoColumns';
import compareKeyMetricsColumns from './compareKeyMetricsColumns';
import compareKeyMetricsTableColumns from './compareKeyMetricsTableColumns';
import keyMetricsGoogleTrendsColumns from './keyMetricsGoogleTrendsColumns';
import feedsDetailsColumns from './feedsDetailsColumns';
import voiceReportingTextAnalysisColumns from './voiceReportingTextAnalysisColumns';

export default {
  'Game Store': {
    columns: gameStoreColumns,
  },
  'Social Media': {
    columns: socialMediaColumns,
  }, // 和 feedback 共用
  'Private Source': {
    columns: socialMediaColumns,
  },
  'Player Feedback': {
    columns: socialMediaColumns,
  },
  'Security Channel': {
    columns: socialMediaColumns,
  },
  Chatting: {
    columns: socialMediaColumns,
  },
  'News Media': {
    columns: newsMediaColumns,
  },
  'Private Discord': {
    columns: privateDiscordColumns,
  },
  'Game Store Feeds': {
    columns: gameStoreColumns,
  },
  'Social Media Feeds': {
    columns: socialMediaColumns,
  }, // 和 feedback 共用
  'News Media Feed': {
    columns: newsMediaColumns,
  },
  Sheet: {
    columns: socialMediaColumns,
  },
  Hero: {
    columns: heroColumns,
  },
  Hashtag: {
    columns: hashtagColumns,
  },
  Streamer: {
    columns: streamerColumns,
  },
  Influencer: {
    columns: influencerColumns,
  },
  Video: {
    columns: videoColumns,
  },
  'Video Chart': {
    columns: videoChartColumns,
  },
  'Growth of Followers': {
    columns: accountsChartColumns,
  },
  'Audience Performance': {
    columns: accountsChartColumns,
  },
  Followers: {
    columns: accountsChartColumns,
  },
  'Publishing Performance': {
    columns: accountsChartColumns,
  },
  'Account Metrics Table': {
    columns: accountMetricsTableColumnsColumns,
  },
  TopicTrends: {
    columns: summaryTopicTrendsColumns,
  },
  'Key Metrics': {
    columns: keyMetricsColumns,
  },
  'Steam Performance': {
    columns: steamMetricsColumns,
  },
  'Anchor Words': {
    columns: anchorWordsColumns,
  },
  'First Correlation Words': {
    columns: firstCorrelationWordsColumns,
  },
  'Second Correlation Words': {
    columns: secondCorrelationWordsColumns,
  },
  'Influencer Counts': {
    columns: influencerCounts,
  },
  'Channel Distribution': {
    columns: influencerChannel,
  },
  'Publication Counts': {
    columns: influencerPublicationAnalysisCounts,
  },
  'Performance Analysis': {
    columns: influencerPublicationAnalysisCounts,
  },
  // 这里错误
  'Steam All Reviews': {
    columns: steamRatingsColumns('All Reviews'),
  },
  'Steam Recent Reviews': {
    columns: steamRatingsColumns('Recent Reviews'),
  },
  'Added Reviews': {
    columns: steamRatingsFilterSelectedColumns,
  },
  'Steam Reviews Detailed Language': {
    columns: steamReviewsDetailedLanguageColumns,
  },
  'Steam Reviews Detailed Keyword': {
    columns: feedsKeywordTableColumns,
  },
  'Overview Keyword Timeline': {
    columns: overviewKeywordTableColumns,
  },
  'Realtime Steam All Reviews': {
    columns: steamRealtimeColumns('All Reviews'),
  },
  'Realtime Steam Recent Reviews': {
    columns: steamRealtimeColumns('Recent Reviews'),
  },
  'Realtime Added Reviews': {
    columns: steamRealtimeFilteredReviewsColumns,
  },
  'Realtime Added Stacked Reviews': {
    columns: steamRealtimeFilteredReviewsColumns,
  },
  'Steam Realtime Newly Added': {
    columns: steamRealtimeNewlyAddedColumns,
  },
  'Compare By Influencer': {
    columns: compareByInfluencerColumns,
  },
  'Filtered Creator Language Distribution': {
    columns: genreLanguageListColumns,
  },
  'Genre Creator List': {
    columns: genreCreatorListColumns,
  },
  TrendingVideo: {
    columns: trendingVideoColumns,
  },
  'Mentions & Sentiment': {
    columns: compareKeyMetricsColumns,
  },
  'Game Store - Google Play': {
    columns: compareKeyMetricsColumns,
  },
  'Game Store - App Store': {
    columns: compareKeyMetricsColumns,
  },
  'Game Store - Steam': {
    columns: compareKeyMetricsColumns,
  },
  'Community - Potential Impressions': {
    columns: compareKeyMetricsColumns,
  },
  'Community - Publications': {
    columns: compareKeyMetricsColumns,
  },
  'Community - Number of Creators': {
    columns: compareKeyMetricsColumns,
  },
  'Community - Views': {
    columns: compareKeyMetricsColumns,
  },
  'Community - Engagement': {
    columns: compareKeyMetricsColumns,
  },
  'Community - Hours Watched': {
    columns: compareKeyMetricsColumns,
  },
  'Community - Sessions': {
    columns: compareKeyMetricsColumns,
  },
  'Community - Streamers': {
    columns: compareKeyMetricsColumns,
  },
  'Community - Peak CCV': {
    columns: compareKeyMetricsColumns,
  },
  'Community - Avg CCV': {
    columns: compareKeyMetricsColumns,
  },
  'Community - Engagement Rate': {
    columns: compareKeyMetricsColumns,
  },
  'Community - Followers': {
    columns: compareKeyMetricsColumns,
  },
  'Google Trends': {
    columns: compareKeyMetricsColumns,
  },
  PR: {
    columns: compareKeyMetricsColumns,
  },
  'Compare Key Metrics Mentions & Sentiment Table': {
    columns: compareKeyMetricsTableColumns('MentionsSentiment'),
  },
  'Compare Key Metrics Game Store Table': {
    columns: compareKeyMetricsTableColumns('GameStore'),
  },
  'Compare Key Metrics Community Table': {
    columns: compareKeyMetricsTableColumns('Community'),
  },
  'Compare Key Metrics PR Table': {
    columns: compareKeyMetricsTableColumns('PR'),
  },
  'Compare Key Metrics Steam Table': {
    columns: compareKeyMetricsTableColumns('Steam'),
  },
  'Key Metrics Google Trends': {
    columns: keyMetricsGoogleTrendsColumns,
  },
  'Post Reviews': {
    columns: feedsDetailsColumns,
  },
  'Voice Reporting Text Analysis Details': {
    columns: voiceReportingTextAnalysisColumns
  }
};
